import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function FunctionalMathsLevel2() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Thank you! We will get back to you within 24 hours.');
    setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
  };
  return (
    <>
      <Header />
      
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dkt3.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Animated Pattern Overlay */}
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          
          {/* Gradient Border Bottom */}
          <div style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '5px',
            background: 'linear-gradient(90deg, #B17ACC 0%, #7B3F9E 50%, #B17ACC 100%)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 3s ease-in-out infinite'
          }}></div>
          
          <div className="container" style={{ position: 'relative', zIndex: 2, padding: '80px 20px' }}>
            <div className="row justify-content-center text-center">
              <div className="col-lg-8">
                {/* Animated Badge */}
                <div style={{
                  display: 'inline-block',
                  backgroundColor: 'rgba(123, 63, 158, 0.2)',
                  backdropFilter: 'blur(10px)',
                  padding: '12px 30px',
                  borderRadius: '50px',
                  marginBottom: '30px',
                  border: '2px solid rgba(123, 63, 158, 0.4)',
                  boxShadow: '0 4px 20px rgba(123, 63, 158, 0.2)'
                }}>
                  <span style={{ 
                    color: '#e0d9e4ff', 
                    fontSize: '0.9rem', 
                    fontWeight: '700', 
                    letterSpacing: '2px',
                    textShadow: '0 0 10px rgba(123, 63, 158, 0.5)'
                  }}>
                    📐 LEVEL 2 QUALIFICATION
                  </span>
                </div>
                
                <h1 style={{ 
                  fontSize: '4.5rem', 
                  fontWeight: '800',
                  color: 'white',
                  marginBottom: '30px',
                  lineHeight: '1.1',
                  letterSpacing: '-2px',
                  textShadow: '0 4px 30px rgba(0,0,0,0.5), 0 0 60px rgba(123, 63, 158, 0.2)'
                }}>
                  Functional Skills Maths Level 2
                </h1>
                
                {/* Decorative Line */}
                <div style={{
                  width: '150px',
                  height: '6px',
                  background: 'linear-gradient(90deg, transparent, #B17ACC, transparent)',
                  margin: '0 auto 35px',
                  borderRadius: '10px',
                  boxShadow: '0 0 20px rgba(123, 63, 158, 0.5)'
                }}></div>
                
                <p style={{
                  fontSize: '1.4rem',
                  color: 'rgba(255,255,255,0.95)',
                  maxWidth: '700px',
                  margin: '0 auto',
                  lineHeight: '1.8',
                  textShadow: '0 2px 15px rgba(0,0,0,0.3)',
                  fontWeight: '300'
                }}>
                  GCSE equivalent qualification in Maths
                </p>
              </div>
            </div>
          </div>
          
          <style>{`
            @keyframes float {
              0%, 100% { transform: translateY(0px); }
              50% { transform: translateY(-20px); }
            }
            @keyframes shimmer {
              0% { background-position: 200% 0; }
              100% { background-position: -200% 0; }
            }
          `}</style>
        </section>

        {/* Content Section */}
        <section id="functional-maths-level-2" className="section" style={{ padding: '80px 0' }}>
          <div className="container" data-aos="fade-up">
            
            <div className="row justify-content-center">
              <div className="col-lg-10">
                
                {/* Overview */}
                <div className="mb-5 p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h2 style={{ 
                    fontSize: '2.5rem', 
                    fontWeight: '700', 
                    color: '#1e293b',
                    marginBottom: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <span style={{ fontSize: '2rem' }}>🔢</span> Functional Skills Maths - Exam Only – Online
                  </h2>
                  <div style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                    <p>
                      Need to sit an official exam and achieve a qualification in Maths? We are your solution! After passing the Maths exam, you will achieve the Maths Functional Skills Level 2 certificate.
                    </p>
                    <p style={{
                      backgroundColor: '#F5EBFA',
                      padding: '20px',
                      borderRadius: '12px',
                      borderLeft: '4px solid #B17ACC',
                      fontWeight: '600',
                      color: '#7B3F9E',
                      marginBottom: '15px'
                    }}>
                      Functional Skills Maths Level 2 qualifications are nationally recognised and are equivalent to GCSE Grade C (Grade 4).
                    </p>
                    <p style={{ marginBottom: 0 }}>
                      To sit your exam, you will need to complete a short enrolment and a practice test first. You will get access to multiple practice tests and additional resources too.
                    </p>
                  </div>
                </div>

                {/* What's Included */}
                <div className="mb-5 p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ 
                    fontSize: '2rem', 
                    fontWeight: '700', 
                    color: '#1e293b',
                    marginBottom: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <span style={{ fontSize: '1.8rem' }}>📦</span> What Does This Exam Preparation Include?
                  </h3>
                  <ul style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '2', paddingLeft: '25px', marginBottom: 0 }}>
                    <li>Enrolment checklist consisting of an initial assessment, two documents (proof of identity and address) and an enrolment form to upload.</li>
                    <li>Practice past papers and mark schemes for you to pass before you book your official examinations. This will give you the confidence in your current capability before taking the examinations. An experienced tutor will mark them and give you feedback.</li>
                    <li>Our test centre exam includes a computer-based exam or a paper-based version of the non-calculator and calculator exams if needed. The paper-based version takes 10 working days to arrive at the centre.</li>
                    <li>Your final certificate</li>
                  </ul>
                </div>

                {/* Recognition Cards */}
                <div className="row g-4 mb-5">
                  <div className="col-md-6">
                    <div className="p-4 shadow-lg" style={{ 
                      backgroundColor: '#fff',
                      borderRadius: '24px',
                      border: '1px solid #e2e8f0',
                      height: '100%'
                    }}>
                      <h4 style={{ fontSize: '1.3rem', fontWeight: '700', color: '#7B3F9E', marginBottom: '15px' }}>
                        ✅ Is This Exam Recognised?
                      </h4>
                      <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: 0 }}>
                        Yes, this exam and certificate is Ofqual regulated and accepted by universities and employers as a GCSE Equivalent.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="p-4 shadow-lg" style={{ 
                      backgroundColor: '#fff',
                      borderRadius: '24px',
                      border: '1px solid #e2e8f0',
                      height: '100%'
                    }}>
                      <h4 style={{ fontSize: '1.3rem', fontWeight: '700', color: '#7B3F9E', marginBottom: '15px' }}>
                        🏆 What awarding body is the qualification with?
                      </h4>
                      <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: 0 }}>
                        For our exams, the awarding body is <strong>NCFE</strong>, one of the UK's top awarding bodies.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Qualification Structure */}
                <div className="mb-5 p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ 
                    fontSize: '2rem', 
                    fontWeight: '700', 
                    color: '#1e293b',
                    marginBottom: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <span style={{ fontSize: '1.8rem' }}>📝</span> How many exams will I have to pass to get my certificate?
                  </h3>
                  <p style={{ fontSize: '1.05rem', color: '#475569', marginBottom: '20px' }}>
                    There is a 1-exam that you need to complete for Maths, and it is split into two parts:
                  </p>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div style={{
                        backgroundColor: '#fef3c7',
                        padding: '25px',
                        borderRadius: '12px',
                        border: '2px solid #f59e0b',
                        textAlign: 'center'
                      }}>
                        <div style={{ fontSize: '3rem', marginBottom: '10px' }}>🚫</div>
                        <div style={{ fontSize: '1.2rem', fontWeight: '700', color: '#92400e', marginBottom: '8px' }}>
                          non-Calculator
                        </div>
                        <div style={{ fontSize: '1rem', color: '#78350f' }}>
                          30 minutes
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div style={{
                        backgroundColor: '#F5EBFA',
                        padding: '25px',
                        borderRadius: '12px',
                        border: '2px solid #B17ACC',
                        textAlign: 'center'
                      }}>
                        <div style={{ fontSize: '3rem', marginBottom: '10px' }}>🔢</div>
                        <div style={{ fontSize: '1.2rem', fontWeight: '700', color: '#7B3F9E', marginBottom: '8px' }}>
                          Calculator
                        </div>
                        <div style={{ fontSize: '1rem', color: '#475569' }}>
                          1 hour 30 minutes
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Exam Availability */}
                <div className="mb-5 p-5 shadow-lg" style={{ 
                  backgroundColor: '#F5EBFA',
                  borderRadius: '24px',
                  border: '2px solid #B17ACC'
                }}>
                  <h3 style={{ 
                    fontSize: '2rem', 
                    fontWeight: '700', 
                    color: '#7B3F9E',
                    marginBottom: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <span style={{ fontSize: '1.8rem' }}>📅</span> What is the availability for exam days?
                  </h3>
                  <div style={{ color: '#1e293b', fontSize: '1.05rem', lineHeight: '1.8' }}>
                    <h4 style={{ fontSize: '1.2rem', fontWeight: '600', marginBottom: '15px' }}>In-Centre Online Examinations</h4>
                    <p style={{ marginBottom: '10px' }}>
                      <strong>Weekdays (Mon-Fri):</strong> 10 AM – 6:00 PM
                    </p>
                    <p style={{ marginBottom: '10px' }}>
                      <strong>Saturday mornings (occasional):</strong> 10 AM – 2:00 PM
                    </p>
                    <p style={{
                      backgroundColor: '#fef3c7',
                      padding: '15px',
                      borderRadius: '8px',
                      borderLeft: '4px solid #f59e0b',
                      marginBottom: 0
                    }}>
                      <strong>Can I do the exams from home?</strong> No.
                    </p>
                  </div>
                </div>

                {/* How to Prepare */}
                <div className="mb-5 p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ 
                    fontSize: '2rem', 
                    fontWeight: '700', 
                    color: '#1e293b',
                    marginBottom: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <span style={{ fontSize: '1.8rem' }}>📚</span> How You Will Learn and Prepare
                  </h3>
                  <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: 0 }}>
                    We provide past exam papers and mark schemes to help you in your preparation.
                  </p>
                </div>

                {/* FAQs */}
                <div className="mb-5 p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ 
                    fontSize: '2rem', 
                    fontWeight: '700', 
                    color: '#1e293b',
                    marginBottom: '30px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <span style={{ fontSize: '1.8rem' }}>❓</span> Frequently Asked Questions
                  </h3>

                  {[
                    {
                      q: "What if I don't pass my exams?",
                      a: "If in the unfortunate event that you are not successful with your examination, you can retake as many times as you like within your 3-month exam duration."
                    },
                    {
                      q: "What if I can't take the exam on my chosen date?",
                      a: "If you cannot attend your exam or miss your exam with less than 2-working days’ notice, you will need to pay the retake fee if you wish to reschedule your exam.If you can provide 2-working days’ notice, we can reschedule your exam with no extra fees. You must receive a confirmation email that your exam has been rescheduled. If you have not received an email with a changed exam date, your exam has not been rescheduled. Please ensure you receive this email."
                    },
                    {
                      q: "Can I get extra time if I have learning difficulties?",
                      a: "You can get extra time providing you email the evidence to admin@dtkcollege.co.uk. The subject line should read: ‘Extra time needed in exam’. An example of evidence would be a GP’s letter stating the reason/s for the extra time requested in the exam. The extra times available vary from 25% to 50%, however 50% extra time is only available in exceptional circumstances."
                    },
                    {
                      q: "Why do I have to complete the enrolment, and the English and Maths assessments?",
                      a: "You must complete the full enrolment for functional skills as it is part of our enrolment procedure and compliance before booking and sitting the exam. They are important because they tell us what level you’re currently working at."
                    }
                  ].map((faq, index) => (
                    <div key={index} style={{
                      marginBottom: index < 3 ? '20px' : '0',
                      paddingBottom: index < 3 ? '20px' : '0',
                      borderBottom: index < 3 ? '1px solid #e2e8f0' : 'none'
                    }}>
                      <h5 style={{ fontSize: '1.15rem', fontWeight: '600', color: '#7B3F9E', marginBottom: '10px' }}>
                        {faq.q}
                      </h5>
                      <p style={{ color: '#475569', fontSize: '1rem', lineHeight: '1.6', marginBottom: 0 }}>
                        {faq.a}
                      </p>
                    </div>
                  ))}
                </div>

                {/* Contact Form */}
                <div className="shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0',
                  overflow: 'hidden'
                }}>
                  <div style={{
                    backgroundColor: '#7b5ba1',
                    color: 'white',
                    padding: '30px',
                    textAlign: 'center'
                  }}>
                    <h3 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '10px', color: '#fff' }}>
                      Need Some More Info?
                    </h3>
                    <p style={{ fontSize: '1.1rem', marginBottom: 0, opacity: 0.9 }}>
                      Fill out the form and we'll get straight back to you with help within 24 hours.
                    </p>
                  </div>
                  <div style={{ padding: '40px' }}>
                    <form onSubmit={handleSubmit}>
                      <div className="row g-3">
                        <div className="col-md-6">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Your name"
                            value={formData.name}
                            onChange={(e) => setFormData({...formData, name: e.target.value})}
                            required
                            style={{
                              padding: '15px',
                              borderRadius: '8px',
                              border: '1px solid #e2e8f0',
                              fontSize: '1rem'
                            }}
                          />
                        </div>
                        <div className="col-md-6">
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Your email"
                            value={formData.email}
                            onChange={(e) => setFormData({...formData, email: e.target.value})}
                            required
                            style={{
                              padding: '15px',
                              borderRadius: '8px',
                              border: '1px solid #e2e8f0',
                              fontSize: '1rem'
                            }}
                          />
                        </div>
                        <div className="col-md-6">
                          <input
                            type="tel"
                            className="form-control"
                            placeholder="Phone*"
                            value={formData.phone}
                            onChange={(e) => setFormData({...formData, phone: e.target.value})}
                            required
                            style={{
                              padding: '15px',
                              borderRadius: '8px',
                              border: '1px solid #e2e8f0',
                              fontSize: '1rem'
                            }}
                          />
                        </div>
                        <div className="col-md-6">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Subject*"
                            value={formData.subject}
                            onChange={(e) => setFormData({...formData, subject: e.target.value})}
                            required
                            style={{
                              padding: '15px',
                              borderRadius: '8px',
                              border: '1px solid #e2e8f0',
                              fontSize: '1rem'
                            }}
                          />
                        </div>
                        <div className="col-12">
                          <textarea
                            className="form-control"
                            rows="5"
                            placeholder="Your message (optional)"
                            value={formData.message}
                            onChange={(e) => setFormData({...formData, message: e.target.value})}
                            style={{
                              padding: '15px',
                              borderRadius: '8px',
                              border: '1px solid #e2e8f0',
                              fontSize: '1rem',
                              resize: 'vertical'
                            }}
                          ></textarea>
                        </div>
                        <div className="col-12">
                          <button
                            type="submit"
                            style={{
                              backgroundColor: '#7B3F9E',
                              color: 'white',
                              padding: '15px 40px',
                              borderRadius: '50px',
                              border: 'none',
                              fontSize: '1.1rem',
                              fontWeight: '600',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              boxShadow: '0 4px 15px rgba(123, 63, 158, 0.3)'
                            }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#6B2F8E'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#7B3F9E'}
                          >
                            Send Message
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default FunctionalMathsLevel2;
